(function () {
    'use strict';

    angular
        .module('bcmModule')
        .controller('biaResponsibilityDependencyController', Controller);

    Controller.$inject = ['$scope', 'adminReferenceDataService'];

    function Controller($scope, adminReferenceDataService) {

        if (_.isUndefined($scope.ctrlCtxt)) $scope.ctrlCtxt = {};

        $scope.dependencyTypes = [];

        init();

        // Save Changes — delegates to parent scope
        $scope.saveChanges = function (form) {
            if (form.$invalid) return;

            // Set typeName from selected type for display
            if ($scope.dependency.typeId && $scope.dependencyTypes.length) {
                var selectedType = _.find($scope.dependencyTypes, { LookupAttributeValueID: $scope.dependency.typeId });
                if (selectedType) {
                    $scope.dependency.typeName = selectedType.TitleEN;
                }
            } else {
                $scope.dependency.typeName = null;
            }

            $scope.onDependencySave($scope.dependency);
        };

        // Cancel
        $scope.onModalClose = function () {
            $scope.close();
        };

        function init() {
            // BCMDependencyType is on ItemType 'BIAResponsibility' (ID 93)
            adminReferenceDataService
                .getLookupAttributeValues('BIAResponsibility')
                .then(function (lookupAttributes) {
                    if (lookupAttributes.BCMDependencyType) {
                        $scope.dependencyTypes = lookupAttributes.BCMDependencyType.LookupAttributeValues || [];
                    }
                })
                .catch(function () {
                    $scope.dependencyTypes = [];
                });
        }
    }
})();
